// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper___UR0r_","navigation":"navigation___XnLRJ","scroll-container":"scroll-container___1nOkH","item":"item___25vCK","pipe":"pipe___3205S","fade":"fade___3K1k9","navBar":"navBar___2x98N"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/Navigation/Navigation.scss
// module id = /P8x
// module chunks = 57